<template>
  <div class="container mx-auto max-w-2xl p-6 lg:pt-12">
    <slot />
  </div>
</template>
